import { render, staticRenderFns } from "./BaseAddSection.vue?vue&type=template&id=cf44921a&"
import script from "./BaseAddSection.vue?vue&type=script&lang=js&"
export * from "./BaseAddSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports